import { cn } from '@/utils/cn';

export interface ProgressBarProps {
  /** 0–100; ignored when indeterminate */
  value?: number;
  indeterminate?: boolean;
  className?: string;
}

export function ProgressBar({ value = 0, indeterminate = false, className }: ProgressBarProps) {
  return (
    <div
      className={cn('h-1.5 w-full overflow-hidden rounded-full bg-white/10', className)}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={indeterminate ? undefined : Math.round(value)}
    >
      {indeterminate ? (
        <div className="h-full w-1/3 rounded-full bg-gradient-to-r from-primary-500 to-accent-500 animate-progress-slide" />
      ) : (
        <div
          className="h-full rounded-full bg-gradient-to-r from-primary-500 to-accent-500 transition-[width] duration-500"
          style={{ width: `${Math.min(100, Math.max(0, value))}%` }}
        />
      )}
    </div>
  );
}
